import React, { useEffect, useRef } from 'react';
import { cx } from '../../lib/cx';

/** Native checkbox (keeps built-in keyboard and screen-reader support) with tri-state. */
export const Checkbox = ({ checked, indeterminate = false, onChange, className, ...props }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className={cx(
        'h-4 w-4 shrink-0 cursor-pointer rounded border-line-strong accent-accent-solid',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
};
